/**
 * The popup-to-opener message contract for the MCP OAuth flow. Sender
 * (`OAuthCallbackHandler`) and listener (`McpConnections`) both import these, so a typo on
 * either side is a compile error rather than a message nobody receives.
 */
import type { OAuthMessageTypes } from "@/shared/components/OAuthCallback/OAuthCallbackPage";

export const MCP_OAUTH_MESSAGES = {
  success: "mcp-oauth-success",
  error: "mcp-oauth-error",
} as const satisfies OAuthMessageTypes;
